import React from 'react';



type Props = {
  className?: string;
}
export const CloseFillVector: React.FC<Props> = ({ className }) => {
  return (
    <svg width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'currentColor' d = 'M10 19C5.0293 19 1 14.9707 1 10C1 5.0293 5.0293 1 10 1C14.9707 1 19 5.0293 19 10C19 14.9707 14.9707 19 10 19ZM10 8.7274L7.4548 6.1813L6.1813 7.4548L8.7274 10L6.1813 12.5452L7.4548 13.8187L10 11.2726L12.5452 13.8187L13.8187 12.5452L11.2726 10L13.8187 7.4548L12.5452 6.1813L10 8.7274Z' />
    </svg>
  );
};
